import React,  { useRef } from "react";
import headerImage from "../../assets/header4.jpg";
import w4_1 from "../../assets/w4_1.jpg";
import w4_2 from "../../assets/w4_2.jpg";
import w4_3 from "../../assets/w4_3.jpg";
import w4_4 from "../../assets/w4_4.jpg";
import w4_5 from "../../assets/w4_5.jpg";
import w4_6 from "../../assets/w4_6.jpg";
import w4_7 from "../../assets/w4_7.jpg";
import w4_8 from "../../assets/w4_8.jpg";
import w4_9 from "../../assets/w4_9.jpg";
import w4_10 from "../../assets/w4_10.png";
import w4_11 from "../../assets/w4_11.jpg";

const Assignment5 = () => {
  const dataSheet = useRef(null);
  const simulation = useRef(null);
  const devBoard = useRef(null);
  const groupAssignment = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>4. Week - Embedded Programming</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">February 19, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}
      <div className="mt-4 flex space-x-4">
        <button onClick={() => scrollToSection(dataSheet)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
         Datasheet
        </button>
        <button onClick={() => scrollToSection(simulation)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Simulation
        </button>
        <button onClick={() => scrollToSection(devBoard)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Development Board
        </button>
        <button onClick={() => scrollToSection(groupAssignment)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Group Assignment
        </button>
        </div>
        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
        This week is about embedded programming. I was a little disappointed that we were obliged to simulate the operation of a microcontroller instead of programming a development board as usual. Nevertheless, as I like programming, this week's assignment was fun and a good opportunity to get back into programming microcontrollers, since I finished my last microcontroller project over a year ago. 
        </p>

        {/* Datasheet Section*/}
        <div ref={dataSheet}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Browsing through the ESP32 Datasheet</h2>
        <p className="text-justify text-gray-700 mb-6">
        The ESP32 is a small but powerful computer chip that can connect to the internet using Wi-Fi (IEEE 802.11 b/g/n (2.4 GHz)) and Bluetooth (Bluetooth v4.2 BR/EDR and Bluetooth LE). It is often used in smart devices, home automation, and IoT (Internet of Things) projects. The chip has one or two processor cores (Xtensa single-/dual-core 32-bit LX6) that can run at up to 240 MHz, which makes it fast. It also has memory (520kB SRAM and 448kB ROM) to store data and programs.</p>
        
  <a
    style={{ marginBottom: "2rem", display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/esp32_datasheet_en.pdf"
    download
  >
    📎 Download Datasheet
  </a>

        <h3 className="text-2xl font-bold text-left mb-6">GPIO Pins and Sensors</h3>
        <p className="text-justify text-gray-700 mb-6">The ESP32 has 34 GPIO pins. These pins can be used to connect buttons, sensors, LEDs, motors, and other electronic parts. Some pins can only be used for input (reading signals), while others can send or receive signals. TThe ESP32 also has special pins for analog sensors, so it can measure voltages and analog values like temperature, light, and humidity</p>
        <img src={w4_1} alt="Pinout" className="my-4 mx-auto rounded shadow-md" />
        <h3 className="text-2xl font-bold text-left mb-6">PWM (Pulse Width Modulation)</h3>
        <p className="text-justify text-gray-700 mb-6">The ESP32 can control motors, LEDs, and other devices using PWM (Pulse Width Modulation). This allows it to dim LEDs smoothly or change the speed of motors. It has 16 PWM channels, so it can control many devices at the same time. The chip also has a special motor control unit, which is useful for robotics and automation projects.</p>

        <h3 className="text-2xl font-bold text-left mb-6">Power and Voltage</h3>
        <p className="text-justify text-gray-700 mb-6">The ESP32 can work with a voltage between 2.3V and 3.6V, but 3.3V is the most common voltage. It has different power modes to save energy:
        <ul>          
        <li><b>Active Mode:</b> Everything is working (Wi-Fi, Bluetooth, CPU)</li>
        <li><b>Modem Sleep Mode:</b> The CPU is running, but Wi-Fi and Bluetooth are off</li>
        <li><b>Light Sleep Mode: </b>The CPU is paused, but it can wake up quickly.</li>
        <li><b>Deep Sleep Mode:</b> Only a small part of the chip is on, using very little power. (10 µA consumption)</li>
        <li><b>Hibernation Mode:</b> Almost everything is off, using almost no power (5 µA consumption)</li>
        </ul>
        This helps battery-powered projects last longer.
        </p>
        <h3 className="text-2xl font-bold text-left mb-6">Wi-Fi and Bluetooth</h3>
        <p className="text-justify text-gray-700 mb-6">The ESP32 can connect to Wi-Fi networks to send and receive data. It can also use Bluetooth, so it can talk to smartphones and other Bluetooth devices. It supports Bluetooth Low Energy (BLE), which uses very little power, making it great for wearable devices and wireless sensors.</p>
        
        <h3 className="text-2xl font-bold text-left mb-6">Why choose the ESP32?</h3>
        <p className="text-justify text-gray-700 mb-6">I chose the ESP32 for my project because of its built-in connectivity features and its simplicity to program. In addition it has many pins for connecting different sensors and devices and supports multiple energy-saving power modes.</p>



        {/* Simulation Section*/}
        <div ref={simulation}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Simulation of a Microcontroller</h2>
        <p className="text-justify text-gray-700 mb-6">I used wokwi.com to simulate the operation of a microcontroller.</p>

        <img src={w4_2} alt="Wokwi" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">Wokwi is an easy-to-use online tool that provides simulations for four different development boards and their simulation on their homepage.

As I want to use the ESP32 in my final project, I decided to use that microcontroller this week too.

I selected the "Starter Template" of the basic ESP32 and by pressing the play button, I compiled the "hello world" - script.</p>


<img src={w4_3} alt="Wokwi" className="my-4 mx-auto rounded shadow-md" />



        <p className="text-justify text-gray-700 mb-6">Next I wanted to simulate the operation of two ultrasonic sensors.</p>

        <img src={w4_4} alt="Ultrasonic Sensor" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">By clicking the "+" button, you can add components to your simulation. I added two ultrasonic sensors and wired them to the ESP32.</p>
        
        <img src={w4_5} alt="Circuit" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">The next step was to write a program. I did a little research and found out that the ultrasonic sensor calculates the distance by using the duration the sound needs to be reflected by the object and returning to the sensor. Thus, the formula to calculate the distance is: (duration × sound speed) / 2.</p>
        <p className="text-justify text-gray-700 mb-6">At the beginning of my program I defined the values for SOUND_SPEED, TIMEOUT and the trigger and echo pins of the sensors</p>
        <p className="text-justify text-gray-700 mb-6">Then, in the void setup(), I set the baud rate to 115200. The Baud rate represents the number of signal changes or symbols transmitted per second. If you select the wrong Baud Rate, your computer will not be able to understand the transmission as it doesn't know where a symbol ends. Therefore it is important for the serial communication with your computer.</p>
        <p className="text-justify text-gray-700 mb-6">Finally, I set the pinMode() of the used pins to OUTPUT for the trigger pins and INPUT for the echo pins.
        </p>
        <p className="text-justify text-gray-700 mb-6">That's it for the setup.</p>
        <p className="text-justify text-gray-700 mb-6">In the loop, I measured the duration of the left and right sensors and calculated the distance. Finally, I printed the results to the simulated computer via Serial.print().</p>
        
        <img src={w4_6} alt="Loop" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">By clicking on the sensors, you can change the measured distance.</p>

        
        <img src={w4_7} alt="Editing Sensors" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">At the bottom of the picture, you can see the measured distances.</p>
        <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Ultrasonic_Sketch.ino" download>📎Download Code</a></li>
        {/* Reflection Section*/}
        <div ref={devBoard}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Development Board</h2>
        <p className="text-justify text-gray-700 mb-6">The next step was to bring the simulation to a real development board. I only had an old ultrasonic sensor at home without pins. So soldering was required. </p> 
        <img src={w4_11} alt="Arduino RP2040" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">I wrote a simple sketch to measure the distance with the ultrasonic sensor using Arduino IDE.</p>
        <img src={w4_10} alt="Arduino IDE" className="my-4 mx-auto rounded shadow-md" />
        <p className="text-justify text-gray-700 mb-6">The distance was measured and displayed in the serial mon</p>
        <p className="text-justify text-gray-700 mb-6"></p>
        <p className="text-justify text-gray-700 mb-6"></p>

        
        {/* Reflection Section*/}
        <div ref={groupAssignment}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Reflection on the Group Assignment</h2>

        <p className="text-justify text-gray-700 mb-6">This week, I explored embedded programming, focusing on different microcontrollers, toolchains, and workflows. I specifically worked with the RP2040 microcontroller and experimented with both the Arduino RP2040 Connect and the Raspberry Pi Pico.</p>

        
        <img src={w4_8} alt="Raspberry Pi Pico" className="my-4 mx-auto rounded shadow-md" />
        
        <img src={w4_9} alt="Arduino Nano RP2040 Connect" className="my-4 mx-auto rounded shadow-md" />

        <p className="text-justify text-gray-700 mb-6">You can find our weekly group assignment on the designated 
          <p> </p>
          <a href="https://fabacademy.org/2025/labs/bottrop/Assignments/week04/" style={{ color: "purple" }}>
     group assignment page
</a>
        .</p>
        <p className="text-justify text-gray-700 mb-6">The RP2040 is a dual-core ARM Cortex-M0+ microcontroller with 30 GPIOs, support for PWM, SPI, I2C, and UART, and an advanced PIO (Programmable I/O) system. Unlike the ESP32, it does not have built-in Wi-Fi or Bluetooth, but it is efficient, fast, and well-suited for real-time applications.</p>
        <p className="text-justify text-gray-700 mb-6">While I had no issues programming C code in the Arduino IDE, I encountered some difficulties when trying to upload new programs to the RP2040 in MicroPython. An old servo control program kept running, preventing new scripts from executing. I resolved this by reflashing the MicroPython firmware, which reset the board. After that, I was able to use Thonny IDE to successfully upload and run a simple "Hello, world!" script.</p>
              

        </div>

  )}
export default Assignment5;